/* eslint-disable */
import React from 'react';
import proptypes from 'prop-types';
const { shape, string, bool } = proptypes;
import { EmtDescription } from '@thd-olt-component-react/emt-generated-content';
import { EmtLinks } from '@thd-olt-component-react/emt-links';
import { Col, Row } from '@thd-olt-component-react/core-ui';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { GiftCardMaintenanceAlert } from '@thd-olt-component-react/gift-cards-information';
import classNames from 'classnames/bind.js';
import styles from '../../templates/giftCard-layout.scss';
import {
  BestSellerGiftCardCarousel,
  GiftCardsListV2
} from '@thd-olt-component-react/gift-cards-list';

const GiftCardLayoutMainSection = ({
  Content, data, path, slug, isFlowDisabled = false
}) => {

  const cx = classNames.bind(styles);
  return (
    <Row className="isBound">
      <Col xs="12" sm="12" md="12" lg="12" className="main-col sui-p-0">
        {isFlowDisabled && (
          <ErrorBoundary name="gift-card-maintenance-alert">
            <div className={cx('giftCard-layout__static-section')}>
              <GiftCardMaintenanceAlert />
            </div>
          </ErrorBoundary>
        )}
        {!isFlowDisabled && (
          <ErrorBoundary name="giftCard-component-best-seller-carousel">
            <>
            <div className="sui-pt-4 md:sui-pb-8">
            <Content.AnchorLinks hideTitle = {true}/>
            </div>
            <BestSellerGiftCardCarousel />
            </>
          </ErrorBoundary>
        )}
        {/* {!isFlowDisabled && (
          <ErrorBoundary name="hero-carousel">
            <div>
              <Content.HeroCarousel />
            </div>
          </ErrorBoundary>
        )} */}
        {!isFlowDisabled && (
          <ErrorBoundary name="banner-section">
            <div className={cx('giftCard-layout__static-section')}>
              <div className={cx('giftCard-layout__medioBanner-section')}>
                <Content.CarouselBanner />
              </div>
            </div>
          </ErrorBoundary>
        )}
        {!isFlowDisabled && (
          <ErrorBoundary name="giftCard-component-brands-category-occasion-carousel">
            <div className={cx('giftCard-layout__static-section')} />
            <GiftCardsListV2 />
          </ErrorBoundary>
        )}
        <ErrorBoundary name="spotlight-section">
          <div className={cx('giftCard-layout__static-section')}>
            <div className={cx('giftCard-layout__spotlight-section')}>
              <Content.SpotlightSection />
            </div>
          </div>
        </ErrorBoundary>
        <ErrorBoundary name="emt-description">
          <div className={cx('giftCard-layout__static-section')}>
            <EmtDescription
              title={data?.layouts?.content?.descriptionNew?.title}
              description={data?.layouts?.content?.descriptionNew?.descriptionText}
              descriptionRichText={data?.layouts?.content?.descriptionNew?.description}
            />

          </div>
        </ErrorBoundary>
        <ErrorBoundary name="content-accordion-section">
          <div className={cx('giftCard-layout__static-section')}>
            {Array.isArray(Content.ContentAccordion) &&
              Content.ContentAccordion.map((Accordion) => (
                <Accordion key={Accordion.id} data={data} />
              ))
            }
          </div>
        </ErrorBoundary>
        <div className="sui-mt-4">
          <EmtLinks
            contentId={slug}
            pageName="articles"
            path={path}
          />
        </div>
      </Col>
    </Row>
  );
};

GiftCardLayoutMainSection.propTypes = {
  Content: shape({}),
  data: shape({}),
  path: string,
  slug: string,
  isFlowDisabled: bool
};

GiftCardLayoutMainSection.displayName = 'GiftCardLayoutMainSection';

export default GiftCardLayoutMainSection;
